import { graphql } from '../../graphql';

export const getAllCities = graphql(`
  query AllCities {
    cities(filter: { scope: ALL }) {
      id
      name
      slug
      latitude
      longitude
    }
  }
`);

export const getPopularCities = graphql(`
  query PopularCities {
    cities(filter: { scope: POPULAR }, limit: 10) {
      id
      name
      slug
    }
  }
`);

export const getCitiesWithItems = graphql(`
  query getCitiesWithItems {
    cities(filter: { scope: WITH_ITEMS }) {
      id
      name
      slug
      latitude
      longitude
    }
  }
`);
